import { render, staticRenderFns } from "./ServicePackageList.vue?vue&type=template&id=655bebb4&"
import script from "./ServicePackageList.vue?vue&type=script&lang=js&"
export * from "./ServicePackageList.vue?vue&type=script&lang=js&"
import style0 from "./ServicePackageList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports